import { ImportContactListResponse, getServiceAsync } from '../../service';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { runOwsRequestWithMonitor, Feature, createOwsError } from '../../shared';

export const importContactList = (bytes: (string | number)[]): Promise<number> =>
    getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'ImportContactList',
            feature: Feature.ImportContacts,
            operation: () =>
                service.Operation.importContactListOperation(
                    service.Factory.ImportContactListRequest({
                        Header: getJsonRequestHeader(),
                        ImportedContactList: { CSVData: bytes as string[] },
                    })
                ),
            transformResponse: (owsResponse: ImportContactListResponse) => owsResponse,
        }).then(owsResponse => {
            if (!owsResponse.WasSuccessful) {
                throw createOwsError({
                    name: 'UnsuccessfulContactImport',
                    message: owsResponse.ErrorMessage,
                });
            }

            return owsResponse.NumberOfContactsImported;
        })
    );
